const componentsFlowNodeEn = {
  peopleGroup: {
    notSet: 'Not set',
  },
};

export default componentsFlowNodeEn;
